module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/main-visual-a97fa8ff3fa82038eb57e397ab1b4d1e.jpg";